import { useCallback, useEffect, useState } from 'react';
import { eaApi } from './eaApi.js';
import { EA_SETTINGS_CHANGED_EVENT } from './eaApi.js';

/** * Group EA toggle (Node aliases it as is_ea_globally_enabled on GET /ea/settings).
 * When OFF: hide strategy module (tab, chart button, builder) — same idea as bot
 * when not subscribed. Open EA positions stay visible; closed EA trades are under
 * Position History → EA filter (no separate EA history tab).
 *
 * Real-time: socket eaSettingsChanged → EA_SETTINGS_CHANGED_EVENT.
 * No XHR polling — strategy CRUD/signals use EA_CHANGED_EVENT separately.
 *
 * null = still loading (treat as hidden to avoid flashing the module for OFF groups).
 */
export function isEaModuleEnabledFromSettings(settings) {
  if (!settings) return false;
  if (settings.is_ea_enabled != null) return Number(settings.is_ea_enabled) === 1;
  return Number(settings.is_ea_globally_enabled) === 1;
}

export default function useEaModuleVisible(userId) {
  const [visible, setVisible] = useState(null);

  const refresh = useCallback(async () => {
    if (!userId) {
      setVisible(false);
      return;
    }
    try {
      const settings = await eaApi.settings();
      setVisible(isEaModuleEnabledFromSettings(settings));
    } catch {
      // Fail closed: do not expose strategy UI if settings cannot be loaded.
      setVisible(false);
    }
  }, [userId]);

  useEffect(() => {
    setVisible(null);
    refresh();
  }, [refresh]);

  useEffect(() => {
    const topWin = (() => { try { return window.top; } catch { return window; } })();
    const onSettings = () => refresh();
    topWin.addEventListener(EA_SETTINGS_CHANGED_EVENT, onSettings);
    return () => {
      topWin.removeEventListener(EA_SETTINGS_CHANGED_EVENT, onSettings);
    };
  }, [refresh]);

  return visible === true;
}
